import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import './NavLanguage.scss';
import { I18n } from '../../../helpers/i18n';
import bgAcc from 'static/svg/acc-bg.svg';
import verified from 'static/images/mvp/verified.png';

function CustomAccountLogo({ user, imgStyle, titleStyle, userLabel }) {
  const [userTypeLabel, setUserTypeLabel] = useState('');
  const [userVerified, setUserVerified] = useState(false);

  useEffect(() => {
    if (userLabel) {
      setUserTypeLabel(userLabel)
      return
    }
    // Check for MVP user type first (explorer/guide)
    if (user.mvpUserType === 'explorer') {
      setUserTypeLabel(I18n.t('account_type_selection_senior'))
    } else if (user.mvpUserType === 'guide') {
      setUserTypeLabel(I18n.t('account_type_selection_senior_buddy'))
    } else if (user.mvpUserType === 'both') {
      setUserTypeLabel(I18n.t('account_type_selection_both'))
    } else if (user.type === 'senior') {
      // Fallback to existing logic for non-MVP users
      setUserTypeLabel(I18n.t('account_type_selection_senior'))
    } else {
      setUserTypeLabel(I18n.t('account_type_selection_senior_buddy'))
    }
  }, [user.type, user.mvpUserType]);

  useEffect(() => {
    if (user.statusVerify === 'verified') {
      setUserVerified(true);
    } else {
      setUserVerified(false);
    }
  }, [user.statusVerify]);

  return (
    <>
      <div className="custom-account-logo">
        <img src={bgAcc} alt="logo" {...(imgStyle && { style: imgStyle })}/>
        <div className="acc-lg-title" {...(titleStyle && { style: titleStyle })}>
          {userVerified && (
            <img 
              src={verified} 
              alt="verified" 
              style={{ 
                width: '10px', 
                height: '10px',
                verticalAlign: 'middle',
                marginBottom: '1px'
              }} 
            />
          )}
           {userTypeLabel}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ user }) => ({ user });
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CustomAccountLogo);
